import { render, staticRenderFns } from "./WordGame.vue?vue&type=template&id=71c2a336&scoped=true"
import script from "./WordGame.vue?vue&type=script&lang=js"
export * from "./WordGame.vue?vue&type=script&lang=js"
import style0 from "./WordGame.vue?vue&type=style&index=0&id=71c2a336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2a336",
  null
  
)

export default component.exports